export default {
  "rainfall": "Rainfall,mm",
  "Evaporation": "Evaporate,g",
  "soilTemp": "SoilTemp,℃",
  "soilHumi": "SoilHumi,%",
  "soilCond": "SoilEC,uS/cm",
  "level": "Level,m",
  "PH": "PH",
  "ORP": "ORP,mv",
  "negativeOxygen": "NAI,pc/cm³",
  "CO2": "CO2,ppm",
  "lightIntensity": "Light,lux",
  "ambientTemp1": "Temp1,℃",
  "ambientHum1": "Humidity1,%",
  "pressure1": "Pressure1,Kpa",
  "Photosynthesis": "Photosyn,μmol/m²",
  "TotalRadiation": "Radiation,HW/m2",
  "ultravioletRays": "UV,W/m²",
  "NetRadiation": "NetRadiat,HW/m²",
  "TVOC": "TVOC,ppm",
  "windSpeed": "WindSpeed,m/s",
  "windDirection": "Wind DIR,°",
  "windScale": "WindScale,Grade",
  "noise1": "Noise1,db",
  "PM10": "PM10,ug/m³",
  "oxygenContent": "Oxygen,%VOL",
  "soilHumi1": "SoilHumi1,%",
  "soilTemp1": "SoilTemp1,℃",
  "soilHumi2": "SoilHumi2,%",
  "soilTemp2": "SoilTemp2,℃",
  "soilHumi3": "SoilHumi3,%",
  "soilTemp3": "SoilTemp3,℃",
  "soilHumi4": "SoilHumi4,%",
  "soilTemp4": "SoilTemp4,℃",
  "soilHumi5": "SoilHumi5,%",
  "soilTemp5": "SoilTemp5,℃",
  "nitrogen": "N,mg/kg",
  "Phosphorus": "P,mg/kg",
  "Potassium": "K,mg/kg",
  "turbidity": "Turbidity,NTU",
  "watertemperature": "Watertemp,℃",
  "Moduletemperature": "Module T,℃",
  "SO2": "SO2,ppm",
  "NO2": "NO2,ppm",
  "CO": "CO,ppm",
  "O3": "O3,ppm",
  "SunHours": "SunHours,h",
  "dewTemp": "DewTemp,℃",
  "RainOrSnow": "RainSnow",
  "soilCond1": "SoilCond1,uS/cm",
  "soilCond2": "SoilCond2,uS/cm",
  "soilCond3": "SoilCond3,uS/cm",
  "soilCond4": "SoilCond4,uS/cm",
  "soilTemp6": "SoilTemp6,℃",
  "soilHumi6": "SoilHumi6,%",
  "soilTemp7": "SoilTemp7,℃",
  "soilHumi7": "SoilHumi7,%",
  "soilTemp8": "SoilTemp8,℃",
  "soilHumi8": "SoilHumi8,%",
  "soilTemp9": "SoilTemp9,℃",
  "soilHumi9": "SoilHumi9,",
  "soilTemp10": "SoilTemp10,℃",
  "soilHumi10": "SoilHumi10,%",
  "soilTemp11": "SoilTemp11,℃",
  "soilHumi11": "SoilHumi11,%",
  "soilTemp12": "SoilTemp12,℃",
  "soilHumi12": "SoilHumi12,%",
  "waterPH": "WaterPH",
  "Waterconductivity": "WaterEC,uS/cm",
  "WaterORP": "WaterORP,mv",
  "ammonia": "Ammonia,ppm",
  "ambientHum": "Humidity,%",
  "ambientTemp": "Temp,℃",
  "snowFall1": "SnowFall1,mm",
  "visibility": "Visibility,m",
  "flows": "Flows,m/s",
  "dissolvedoxygen": "DO,mg/L",
  "Leafhumidity": "LeafHumi,℃",
  "snowFall2": "SnowFall2,mm",
  "snowFall3": "SnowFall3,mm",
  "conductivity": "EC,uS/cm",
  "Altitude": "Altitude,m",
  "longitude": "Longitude,°",
  "latitude": "Latitude,°",
  "pressure": "Pressure,KPa",
  "TSP": "TSP,ug/m³",
  "tnegativeOxygen": "NAI,pc/cm³",
  "noise": "Noise,db",
  "tambientHumidity": "Humidity,%",
  "negativeOxygen3": "NAI3,pc/cm³",
  "negativeOxygen5": "NAI5,pc/cm³",
  "negativeOxygen7": "NAI7,pc/cm³",
  "negativeOxygen6": "NAI6,pc/cm³",
  "negativeOxygen2": "NAI2,pc/cm³",
  "tambientkumidity": "Humidity,%RH",
  "ambientTemperature": "Temp,℃",
  "negativeOxygen1": "NAI,pc/cm³",
  "��PM2.5��": "��PM2.5��",
  "PM2.5": "PM2.5,ug/m³",
  " TSP": " TSP,uug/m³",
  "ambientHumidity": "Humidity,%",
  "negativeOxygen ": "NAI,pc/cm³",
  "negativeOxygen4": "NAI4,pc/cm³",
  "RSSI": "RSSI,dBm",
  " TSP ": " TSP ,ug/m³",
  "ambientkumidity": "Humidity,%RH",
  "ambientHumidity2": "Humidity2,%",
  "noise2": "Noise2,db",
  "pressure2": "Pressure2,KPa",
  "ambientTemperature2": "Temp2,℃",
  "altitude": "Altitude,m",
  "ambienthumidity": "Humidity,%",
  "ambientHumidmty": "Humidity,%",
  "ambientHumkdity": "Humidity,℃",
  "indoornegativeOxygen": "IndoorNAI,pc/cm³",
  "lightIntensity33": "Light33,Lux",
  "Raflow": "Velocity,m/s",
  "Rwater": "WaterLevel,mm",
  "soilPH": "SoilPH",
  "soilTemp13": "SoilTemp13,℃",
  "soilTemp15": "SoilTemp15,℃",
  "SolarVoltage": "SolarVDC,V",
  "Voltage": "Voltage,V",
  "flow": "Flow,m³/s",
  "Leaftemperature": "LeafTemp,℃",
  "soilTempG1": "SoilTempG1,℃",
  "soilTempG2": "SoilTempG2,℃",
  "soilTempG3": "SoilTempG3,℃",
  "soilTempG4": "SoilTempG4,℃",
  "soilTempG5": "SoilTempG5,℃",
  "soilTempG6": "SoilTempG6,℃",
  "soilTempG7": "SoilTempG7,℃",
  "soilTempG8": "SoilTempG8,℃",
  "soilTempG9": "SoilTempG9,℃",
  "snowFall": "SnowFall,mm",
  "Amnitro":"Amnitro,mg/L",
  "Ncumulativeflow-H":"NCumFlow-H,m³",
  "Ncumulativeflow-L":"NCumFlow-L,m³",
  "Pcumulativeflow-H":"PCumFlow-H,m³",
  "Pcumulativeflow-L":"PCumFlow-L,m³",
  "soilCond5":"SoilCond5,uS/cm",
  "soilCond6":"SoilCond6,uS/cm",
  "soilCond7":"SoilCond7,uS/cm",
  "soilCond8":"SoilCond8,uS/cm",
  "soilCond9":"SoilCond9,uS/cm",
  "soilCond10":"SoilCond10,uS/cm",
  "soilCond11":"SoilCond11,uS/cm",
  "Leafhumidity1":"LeafHumi1,%",
  "Leaftemperature1":"LeafTemp1,℃",
  "Leafhumidity2":"LeafHumi2,%",
  "Leaftemperature2":"LeafTemp2,℃",
  "waterTem":"WaterTem,℃",
  "Heatflux":"HeatFlux,W/㎡",
  "innegativeOxygen":"IndoorNAI,pc/cm³",
  "outnegativeOxygen":"OutdoorNAI,pc/cm³",
  "PH1":"PH1",
  "PH2":"PH2",
  "PH3":"PH3",
  "PH4":"PH4",
  "PH5":"PH5",
  "PH6":"PH6",
  "Dptemperature":"DewTemp,℃",
  "Airhumidity":"Humidity,%",
  "Airtemperature":"Temp,℃",
  "Stension":"Stension,kPa",
  "salt":"SoilSalt,ppm",
  "soilEC:":"SoilEC,uS/cm",
  "NH3":"NH3",
  "CH4":"CH4",
  "VOC":"VOC,ppm",
  "Sradiation":"DiffuseRAD,W/m2",
  "Voltage3":"Voltage3,V",
  "Voltage4":"Voltage4,V",
  "Roadtemp":"RoadTemp,℃",
  "Waterfilm":"WaterDep,mm",
  "Glaciation":"IceDepth,mm",
  "Snow":"SnowDepth,mm",
  "Swiftswim":"SlipIndex",
  "Warning":"Warning,mm",
  "waterT":"WaterTemp,℃",
  "current":"Velocity,m/s",
  "Dradiation":"DirectRAD,HW/m2",
  "subunitTemp":"ModuleTem,℃",
  "sunshinetime":"Sunshine,h",
  "COD":"COD,mg/L",
  "dissolvedoxygenBH":"DO SAT",
  "NH3Nwastewater":"NH3N,mg/L",
  "NO2wastewater":"NO2,ppm",
  "nitrogen1":"N 1,mg/kg",
  "Phosphorus1":"P 1,mg/kg",
  "Potassium1":"K 1,mg/kg",
  "nitrogen2":"N 2,mg/kg",
  "Phosphorus2":"P 2,mg/kg",
  "Potassium2":"K 2,mg/kg",
  "nitrogen3":"N 3,mg/kg",
  "Phosphorus3":"P 3,mg/kg",
  "Potassium3":"K 3,mg/kg",
  "nitrogen4":"N 4,mg/kg",
  "Phosphorus4":"P 4,mg/kg",
  "Potassium4":"K 4,mg/kg",
  "snowheight":"snowheight,cm",
  "Speed":"Speed,m/s",
  "course":"Course,°",
  "ambientTemperature3":"Temp3,℃",
  "ambientHumidity3":"Humidity3,%",
  "pressure3":"Pressure3,KPa",
  "ambientTemperature4":"Temp4,℃",
  "ambientHumidity4":"Humidity4,%",
  "pressure4":"Pressure4,KPa",
  "ambientTemperature5":"Temp5,℃",
  "ambientHumidity5":"Humidity5,%",
  "pressure5":"Pressure5,KPa",
  "BVoltage":"CellVDC,V",
  "SVoltage":"SolarVDC,V",
  "H2S":"H2S,ppm",
  "waterCO2":"WaterCO2,ppm",
  "raininess":"RainGrade,mm",
  "salinity":"Salinity,ppm",
  "TDS":"TDS,ppm",
  "Hradiation":"ThermalRAD,HW/m²",
  "heatFlux1":"HeatFlux1,w/m²",
  "heatFlux2":"HeatFlux2,w/m²",
  "hradiation":"hradiation",
  "TotalRadiation1":"TotalRadiation1,HW/m2",
  "TotalRadiation2":"TotalRadiation2,HW/m2",
  "chlorophyll": "chlorophyll",
  "BGalgae": "BGalgae",
  "waterTem2":"waterTem2,℃",
  "residualChlorine":"residualChlorine,mg/L",
  "waterlevel":"waterlevel,mm",
  "pow":"pow,V",
  "soilCO2":"soilCO2,ppm",
  "staticPressure":"staticPressure,kpa",
  "angleX":"angleX,°",
  "angleY":"angleY,°",
  "angleZ":"angleZ,°",
  "waterPressure":"waterPressure,kpa",
  "netRadiation":"netRadiation,W/m²",
  "soilCond12":"soilCond12,uS/cm",
  "KMnO4":"KMnO4,mg/L",
  "phosphorus":"phosphorus,mg/L",
  "conductivity2":"conductivity2,uS/cm",
  "waterT2":"waterT2,℃",
  "Rchlorine":"Rchlorine,mg/L",
  "NO":"NO,ppm",
  "soilPH1":"soilPH1",
  "soilPH2":"soilPH2",
  "soilPH3":"soilPH3",
  "soilPH4":"soilPH4",
  "soilPH5":"soilPH5",
  "soilPH6":"soilPH6",
  "ODOvalue":"ODOvalue,mg/L",
  "ODOfull":"ODOfull,%",
  "Nitrate":"Nitrate,mg/L",
  "accumulate":"accumulate,m³",
  "nitrogen5":"N 5,mg/kg",
  "Phosphorus5":"P 5,mg/kg",
  "Potassium5":"K 5,mg/kg",
  "nitrogen6":"N 6,mg/kg",
  "Phosphorus6":"P 6,mg/kg",
  "Potassium6":"K 6,mg/kg",
  "He":"He,ppm",
  "nitrateNitrogen":"nitrateNitrogen,mg/L",
  "heatFlux":"heatFlux,W/㎡",
  "soilOxygen":"soilOxygen,%VOL",
  "waterconductivity":"waterconductivity,uS/cm",
  "Xangle":"Xangle,°",
  "Yangle":"Yangle,°",
  "Zyangle":"Zyangle,°",
  "Xdrift":"Xdrift,°",
  "Xgression":"Xgression,mm",
  "Ygression":"Ygression,mm",
  "Zgression":"Zgression,mm",
  "VI":"VI,1/m",
  "Radiation": "Radiation,w/m2",
  "RadiationR": "RadiationR,w/m2",
  "RadiationV": "RadiationV,w/m2",
  "waterTSs": "waterTSs,mg/L",
  "TotalPhosphorus": "TotalPhosphorus,mg/L",
  "sunAngle": "sunAngle,°",
  "sunAzimuth": "sunAzimuth,°",
  "Caion": "Caion,mg/L",
  "awWARR": "awWARR,w/m²",
  "atOLR": "atOLR,w/m²",
  "grdOLR": "grdOLR,w/m²",
  "TBI": "TBI,w/m²",
  "CTBI": "CTBI,w/m²",
  "CSW": "CSW,w/m²",
  "COLR": "COLR,w/m²",
  "arSW": "arSW,%",
  "arOLR": "arOLR,%",
  "ambientHumidity1": "H1,%",
  "ambientTemperature1": "T1,℃",
  "NH3Nwater": "NH3Nwater,mg/L",
  "snowHeight": "snowHeight,mm",
  "soilNitrogen": "N,mg/kg",
  "soilPhosphorus": "P,mg/kg",
  "soilPotassium": "K,mg/kg",
  "soilNitrogen1":"N 1,mg/kg",
  "soilPhosphorus1":"P 1,mg/kg",
  "soilPotassium1":"K 1,mg/kg",
  "soilNitrogen2":"N 2,mg/kg",
  "soilPhosphorus2":"P 2,mg/kg",
  "soilPotassium2":"K 2,mg/kg",
  "soilNitrogen3":"N 3,mg/kg",
  "soilPhosphorus3":"P 3,mg/kg",
  "soilPotassium3":"K 3,mg/kg",
  "soilNitrogen4":"N 4,mg/kg",
  "soilPhosphorus4":"P 4,mg/kg",
  "soilPotassium4":"K 4,mg/kg",
  "soilNitrogen5":"N 5,mg/kg",
  "soilPhosphorus5":"P 5,mg/kg",
  "soilPotassium5":"K 5,mg/kg",
  "soilNitrogen6":"N 6,mg/kg",
  "soilPhosphorus6":"P 6,mg/kg",
  "soilPotassium6":"K 6,mg/kg",
  "empty":"empty,M",
  "eor":"eor,%",
  "dose":"dose,uSv/h",
  "dosen":"dosen,nSv/h",
  "Weather":"Weather",
  "ponDing":"ponDing,mm",
  "andFlow":"andFlow,m³",
  "soak":"soak",
  "CODmn":"CODmn",
  "NH3N":"NH3N",
  "TP":"TP",
  "TN":"TN",
  "DO":"DO",
  "Turb":"Turb",
  "EC":"EC",
  "Temp":"Temp",
  "amh":"amh,%RH",
  "pre":"pre,Kpa",
  "noi":"noi,db",
  "p25":"p25,ug/m³",
  "p10":"p10,ug/m³",
  "neg":"neg,个/cm³",
  "oxy":"oxy,%VOL",
  "wsp":"wsp,m/s",
  "wdr":"wdr,°",
  "amt":"amt,℃",
  "Rad":"Rad,w/m2",
  "sut":"sut,h",
  "lig":"lig,lux",
  "sH1":"sH1,%",
  "sT1":"sT1,℃",
  "sH2":"sH2,%",
  "sT2":"sT2,℃",
  "sH3":"sH3,%",
  "sT3":"sT3,℃",
  "sH4":"sH4,%",
  "sT4":"sT4,℃",
  "Radia":"Radia,w/m2",
  "sunTme":"sunTme,h",
  "Rhour":"Rhour,wh/m2",
  "Rday":"Rday,wh/m2",
  "Rsum":"Rsum,wh/m2",
  "count":"count,CPS",
  "flow2":"flow2",
  "Rwater2":"Rwater2,mm",
  "solarFlat":"solarFlat,W/m2",
  "solarAngle":"solarAngle,W/m2",
  "bgalgae":"bgalgae,cells/ml",
  "ch2o":"ch2o,ppm",
  "soilhorn":"soilhorn,°",
  "surfaceTemp":"surfaceTemp,℃",
  "litterRH1":"litterRH1,%",
  "litterRH2":"litterRH2,%",
  "litterRH3":"litterRH3,%",
  "surfaceT":"surfaceT,℃",
  "surfaceW":"surfaceW,%RH",
  "waterEC":"waterEC,μS/cm",
  "CH2O":"CH2O,ppm",
  "Hagne":"Hagne,mg/L",
  "CUMEvapm":"CUMEvapm,mm",
  "CUMEvapg":"CUMEvapg,g",
  "Evapg":"Evapg,g",
  "Evapm":"Evapm,mm",
  "fxd_BatVoltage":"BatVoltage,V",
  "fxd_fanMode":"fanMode",
  "fxd_latitude":"latitude,°",
  "fxd_longitude":"longitude,°",
  "fxd_PanelVoltage":"PanelVoltage,V",
  "fxd_RSSI":"RSSI,dBm",
  "fxd_uvMode":"Mode",
  "Magne":"Magne",
  "chloribe":"chloribe,mg/L",
  "smokeAlarm":"smokeAlarm,ppm",
  "seston":"seston,mg/L",
  "cabletemp":"cabletemp,℃",
  "sS":"sS,%",
  "sW":"sW,%",
  "sD":"sD,%",
  "sh":"sh,°",
  "sTe":"surfaceT,℃",
  "sHu":"surfaceW,%RH",
  "wS":"windSpeed,m/s",
  "wD":"windDirection,°",
  "aT":"ambientTemp,℃",
  "aH":"ambientHum,%",
  "pr":"pressure,KPa",
  "li":"Light,lux",
  "ra":"rainfall,mm",
  "lo":"longitude,°",
  "la":"latitude,°",
  "height":"height,m",
  "alt":"alt,m",
  "lat":"lat,°",
  "lon":"lon,°",
  "soilCond13": "soilCond13,uS/cm",
  "soilHumi13": "soilHumi13,%",
  "soilCond14": "soilCond14,uS/cm",
  "soilHumi14": "soilHumi14,%",
  "soilTemp14": "soilTemp14,℃",
  "soilCond15": "soilCond15,uS/cm",
  "soilHumi15": "soilHumi15,%",
  "soilCond16": "soilCond16,uS/cm",
  "soilHumi16": "soilHumi16,%",
  "soilTemp16": "soilTemp16,℃",
  "soilCond17": "soilCond17,uS/cm",
  "soilHumi17": "soilHumi17,%",
  "soilTemp17": "soilTemp17,℃",
  "soilCond18": "soilCond18,uS/cm",
  "soilHumi18": "soilHumi18,%",
  "soilTemp18": "soilTemp18,℃",
  "soilCond19": "soilCond19,uS/cm",
  "soilHumi19": "soilHumi19,%",
  "soilTemp19": "soilTemp19,℃",
  "soilCond20": "soilCond20,uS/cm",
  "soilHumi20": "soilHumi20,%",
  "soilTemp20": "soilTemp20,℃",
  "ammoniaIon": "ammoniaIon,mg/L",
  "flowNum": "flow,mL",
  "Chromaticity": "Chromaticity",
  "sludge": "sludge,g/L",
  "vSpeedX": "vSpeedX,mm/s",
  "vSpeedY": "vSpeedY,mm/s",
  "vSpeedZ": "vSpeedZ,mm/s",
  "vdrftX": "vdrftX,μm",
  "vdrftY": "vdrftY,μm",
  "vdrftZ": "vdrftZ,μm",
  "vPlusX": "vPlusX,m/s2",
  "vPlusZ": "vPlusZ,m/s2",
  "vibrfrHzX": "vibrfrHzX,Hz",
  "vibrfrHzY": "vibrfrHzY,Hz",
  "vibrfrHzZ": "vibrfrHzZ,Hz",
  "dewtemp": "dewtemp,℃",
  "Sunlight_h": "sunTme,h",
  "ambientHumidity6":"Humidity6,%",
  "ambientTemperature6": "Temp6,℃",
  "pressure6":"Pressure6,KPa",
  "windDirection1": "Wind DIR1,°",
  "windDirection2": "Wind DIR2,°",
  "windDirection3": "Wind DIR3,°",
  "windDirection4": "Wind DIR4,°",
  "windDirection5": "Wind DIR5,°",
  "windDirection6": "Wind DIR6,°",
  "windSpeed1": "WindSpeed1,m/s",
  "windSpeed2": "WindSpeed2,m/s",
  "windSpeed3": "WindSpeed3,m/s",
  "windSpeed4": "WindSpeed4,m/s",
  "windSpeed5": "WindSpeed5,m/s",
  "windSpeed6": "WindSpeed6,m/s",
  "Vibr1":"Vibr1",
  "Temp1":"Temp1",
  "Vibr2":"Vibr2",
  "PAR":"PAR,W/m2",
  "UVAB":"UVAB,W/m2",
  "Radia1":"Radia1,w/m2",
  "Rday1":"Rday1,j/cm2",
  "PM25":"PM2.5,ug/m³",
  "�y": "�y"
};



// WEBPACK FOOTER //
// ./src/lang/en.js